module.exports = __webpack_public_path__ + "img/T4-B-xh_8.448b3242.png";